exports.components = {
  "component---src-pages-404-index-tsx": () => import("./../../../src/pages/404/index.tsx" /* webpackChunkName: "component---src-pages-404-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-single-gallery-index-tsx": () => import("./../../../src/templates/singleGallery/index.tsx" /* webpackChunkName: "component---src-templates-single-gallery-index-tsx" */)
}

